import moment from 'moment'

import { AccountingTz, getTzAbbr } from '~/utils/timezone'

export function formatWithLocalTimezone(
  date: Date,
  options: {
    format?: string
    tz?: AccountingTz
  } = {},
) {
  const { format, tz = 'local' } = options
  const timeZoneName = getTzAbbr(tz, date)
  const m = tz === 'utc' ? moment(date).utc() : moment(date).local()

  return m.format(`${format ?? 'MMM Do YYYY HH:mm:ss'} [${timeZoneName}]`)
}

export const ONE_WEEK_MS = 1000 * 60 * 60 * 24 * 7
export const getTimeDiffMs = (timestamp: number | string) => {
  return new Date().getTime() - new Date(timestamp).getTime()
}

export const calendarDaysBetween = (from: Date, to: Date) => {
  const calendarDay = (date: Date) =>
    Date.UTC(date.getFullYear(), date.getMonth(), date.getDate())

  return (calendarDay(to) - calendarDay(from)) / (1000 * 60 * 60 * 24)
}

export const dayOfMonthLabel = (date: Date) => {
  const day = date.getDate()
  const suffix =
    day % 10 === 1 && day !== 11
      ? 'st'
      : day % 10 === 2 && day !== 12
        ? 'nd'
        : day % 10 === 3 && day !== 13
          ? 'rd'
          : 'th'
  return `the ${day}${suffix}`
}
